<template>
  <CCard>
    <CCardHeader style="background-color: #145654;"
      class="border-bottom d-flex justify-content-between align-items-center">
      <h4 class="card-title mb-0 text-white">
        <CIcon name="cil-briefcase" size="xl" /> {{ $t('jobTypeMgmt.pageTitle') }}
      </h4>
      <div class="d-flex align-items-center gap-2 btn-add-mobile">
        <CButton v-if="selectedCategories.length > 0" color="danger" shape="pill" @click="deleteMultipleCategories()">
          <CIcon name="cil-trash" /> {{ $t('staffMgmt.deleteSelected') }} ({{ selectedCategories.length }})
        </CButton>
        <CButton color="success" shape="pill" @click="openAddModal">
          <CIcon name="cil-plus" />
          &nbsp;{{ $t('jobTypeMgmt.addDept') }}
        </CButton>
      </div>
    </CCardHeader>
    <CCardBody>


      <CDataTable 
        class="custom-pagination"
        :items="categoriesData" 
        :fields="categoryFields" 
        hover striped sorter
        :pagination="{ doubleArrows: false, align: 'center' }"
        :items-per-page="perPage" 
        :active-page="activePage"
        @page-change="activePage = $event"
        @pagination-change="perPage = $event"
        @filtered-items-change="onFilteredItemsChange"
        table-filter 
        items-per-page-select
        responsive>
        <template #select-header>
          <input type="checkbox" @change="toggleSelectAll($event.target.checked)" :checked="isPageSelected" style="cursor: pointer; width: 1.2em; height: 1.2em;" />
        </template>

        <template #select="{ item }">
          <td class="text-center align-middle">
            <input type="checkbox" :value="item._id" v-model="selectedCategories" style="cursor: pointer; width: 1.2em; height: 1.2em;" />
          </td>
        </template>

        <!-- แสดงชื่อแผนก -->
        <template #departmentName="{ item }">
          <td>
            <strong>{{ item.departmentName }}</strong>
          </td>
        </template>

        <!-- Column: subCategories (table ย่อย) -->
        <template #subCategories="{ item }">
          <table class="table table-sm table-bordered mb-0 fixed-table">
            <thead>
              <tr>
                <th style="width: 15%" class="text-center">{{ $t('jobTypeMgmt.icon') }}</th>
                <th class="col-40">{{ $t('jobTypeMgmt.jobTypeName') }}</th>
                <th class="col-20">{{ $t('jobTypeMgmt.slaHours') }}</th>
                <th class="col-20">{{ $t('jobTypeMgmt.status') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sub, index) in item.subCategories" :key="index">
                <td class="text-center align-middle">
                  <img v-if="sub.icon" :src="`${appUrl}${sub.icon}`" style="max-height: 30px; max-width: 30px; object-fit: contain;" alt="icon" />
                  <span v-else class="text-muted">-</span>
                </td>
                <td class="align-middle">{{ sub.name }}</td>
                <td class="align-middle">{{ sub.slaHours }}</td>
                <td class="align-middle">
                  <CBadge :color="sub.isActive !== false ? 'success' : 'secondary'">
                    {{ sub.isActive !== false ? $t('jobTypeMgmt.active') : $t('jobTypeMgmt.inactive') }}
                  </CBadge>
                </td>
              </tr>
            </tbody>
          </table>
        </template>

        <!-- ปุ่มแสดงรายละเอียด -->
        <template #show_details="{ item }">
          <td class="py-2 text-center">
            <CCol>
              <CRow class="mb-2">
                <CButton size="sm" color="warning" shape="pill" @click="openEditModal(item)">
                  <CIcon name="cil-pencil" />
                </CButton>
                <CButton size="sm" color="danger" shape="pill" class="ml-2" @click="removeDepartment(item)">
                  <CIcon name="cil-trash" />
                </CButton>
              </CRow>
            </CCol>
          </td>
        </template>
      </CDataTable>

      <!-- Modal เพิ่มหน่วยงานใหม่ -->
      <CModal :title="$t('jobTypeMgmt.addDeptModal')" size="md" :show.sync="addModal">
        <div>
          <CInput :label="$t('jobTypeMgmt.deptNameInput')" :placeholder="$t('jobTypeMgmt.deptPlaceholder')"
            v-model="newDepartmentName" />
        </div>

        <template #footer>
          <div class="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <CButton shape="pill" color="info" @click="triggerExcelUpload" class="mr-2">
                <CIcon name="cil-file" /> {{ $t('staffMgmt.addViaXlsx') || 'Import XLSX' }}
              </CButton>
            </div>
            <div>
              <CButton shape="pill" color="secondary" @click="addModal = false">{{ $t('mgmt.cancel') }}</CButton>
              <CButton shape="pill" color="success" @click="addDepartment">{{ $t('mgmt.add') }}</CButton>
            </div>
          </div>
          <input type="file" ref="excelInput" accept=".xlsx, .xls" class="d-none" @change="handleExcelUpload" />
        </template>
      </CModal>

      <CModal :title="$t('staffMgmt.previewModal') || 'Preview'" :show.sync="showPreviewModal" size="lg" color="info" centered>
        <CModalBody>
          <CDataTable :items="previewDepts" :fields="previewFields" hover striped responsive pagination :items-per-page="5">
          </CDataTable>
        </CModalBody>
        <template #footer>
          <CButton shape="pill" color="danger" @click="showPreviewModal = false">{{ $t('mgmt.cancel') }}</CButton>
          <CButton shape="pill" color="success" @click="confirmUpload">{{ $t('staffMgmt.confirmBulk') || 'Confirm' }}</CButton>
        </template>
      </CModal>

      <!-- Modal -->
      <CModal :title="$t('jobTypeMgmt.editModal')" size="" :show.sync="editModal">
        <CModalBody v-if="selectedDepartment">
          <CInput :label="$t('jobTypeMgmt.deptNameInput')" v-model="selectedDepartment.departmentName" />

          <!-- Hidden File Input for Icon Upload -->
          <input type="file" ref="iconInput" style="display: none;" @change="handleFileUpload" accept="image/png, image/jpeg" />

          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th style="width: 40px;" class="text-center">
                  <input type="checkbox" @change="toggleSelectAllSub($event.target.checked)" 
                         :checked="selectedSubCategories.length === selectedDepartment.subCategories.length && selectedDepartment.subCategories.length > 0" />
                </th>
                <th style="width: 60px;" class="text-center">{{ $t('jobTypeMgmt.icon') }}</th>
                <th>{{ $t('jobTypeMgmt.jobTypeName') }}</th>
                <th style="width: 100px;" class="text-center">{{ $t('jobTypeMgmt.slaShort') }}</th>
                <th style="width: 80px;" class="text-center">{{ $t('jobTypeMgmt.status') }}</th>
                <th style="width: 50px;" class="text-center">{{ $t('jobTypeMgmt.colDelete') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sub, index) in selectedDepartment.subCategories" :key="index">
                <td class="text-center align-middle">
                  <input type="checkbox" :value="index" v-model="selectedSubCategories" />
                </td>
                <td class="text-center align-middle">
                  <div class="d-flex flex-column align-items-center justify-content-center">
                    <div @click="triggerFileUpload(index)" style="cursor: pointer; position: relative;" :title="$t('jobTypeMgmt.uploadIconHint')">
                      <img v-if="sub.icon" :src="`${appUrl}${sub.icon}`" style="height: 35px; width: 35px; object-fit: contain; border: 1px dashed #ccc; padding: 2px;" alt="icon" />
                      <div v-else style="height: 35px; width: 35px; border: 1px dashed #ccc; display: flex; align-items: center; justify-content: center; color: #999;">
                        <CIcon name="cil-image-plus" size="sm" />
                      </div>
                    </div>
                    <button v-if="sub.icon" type="button" @click.prevent="clearIcon(index)" class="btn btn-sm btn-link text-danger p-0 mt-1" style="font-size: 11px; text-decoration: underline;">
                      {{ $t('jobTypeMgmt.removeImage') }}
                    </button>
                  </div>
                </td>
                <td class="align-middle">
                  <input v-model="sub.name" type="text" class="form-control form-control-sm" />
                </td>
                <td class="align-middle">
                  <input v-model.number="sub.slaHours" type="number" min="1"
                    class="form-control form-control-sm text-center" />
                </td>
                <td class="text-center align-middle">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" :id="'switch-'+index"
                      :checked="sub.isActive !== false"
                      @change="sub.isActive = $event.target.checked" />
                    <label class="custom-control-label" :for="'switch-'+index"></label>
                  </div>
                </td>
                <td class="text-center align-middle">
                  <CButton color="danger" size="sm" variant="ghost" @click="removeSubCategory(index)">
                    <CIcon name="cil-trash" />
                  </CButton>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="text-center">
                  <CButton v-if="selectedSubCategories.length > 0" color="danger" size="sm" class="mr-2" @click="removeSelectedSubCategories">
                    <CIcon name="cil-trash" /> {{ $t('jobTypeMgmt.deleteSelectedSub') }} ({{ selectedSubCategories.length }})
                  </CButton>
                  <CButton color="success" size="sm" @click="addSubCategory">
                    <CIcon name="cil-plus" />&nbsp;{{ $t('jobTypeMgmt.addNewSub') }}
                  </CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </CModalBody>
        <template #footer>
          <CButton color="secondary" @click="editModal = false">{{ $t('mgmt.cancel') }}</CButton>
          <CButton color="primary" @click="saveChanges">{{ $t('mgmt.save') }}</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

export default {
  name: "JobTypeManagement",
  data() {
    return {
      selectedCategories: [],
      selectedSubCategories: [],
      categoriesData: [],
      editModal: false,
      addModal: false,
      selectedDepartment: null,
      newDepartmentName: "",
      appUrl: process.env.VUE_APP_APP_URL || "",
      currentUploadIndex: null,
      showPreviewModal: false,
      previewDepts: [],
      activePage: 1,
      perPage: 5,
      filteredCategories: [],
    };
  },

  created() {
    this.loadCategories();
  },

  computed: {
    categoryFields() {
      return [
        { key: "select", label: "", _style: "width: 1%; text-align: center;", sorter: false, filter: false },
        { key: "departmentName", label: this.$t("jobTypeMgmt.deptNameCol"), _style: "width:20%" },
        { key: "subCategories", label: this.$t("jobTypeMgmt.jobTypesCol"), _style: "width:70%" },
        { key: "show_details", label: "", _style: "width:10%" },
      ];
    },
    previewFields() {
      return [
        { key: "departmentName", label: this.$t("jobTypeMgmt.deptNameCol") }
      ];
    },
    currentPageCategories() {
      const start = (this.activePage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredCategories.slice(start, end);
    },
    isPageSelected() {
      if (this.currentPageCategories.length === 0) return false;
      return this.currentPageCategories.every(c => this.selectedCategories.includes(c._id));
    },
  },

  methods: {
    // โหลดข้อมูลหน่วยงาน
    async loadCategories() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_APP_URL}/category`);
        this.categoriesData = res.data.data;
        this.filteredCategories = JSON.parse(JSON.stringify(this.categoriesData));
      } catch (err) {
        console.error(err);
        Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.loadFail"), "error");
      }
    },

    // เปิด modal เพิ่ม
    openAddModal() {
      this.newDepartmentName = "";
      this.addModal = true;
    },

    // ส่งไป backend → POST /category
    async addDepartment() {
      if (!this.newDepartmentName.trim()) {
        Swal.fire(this.$t("mgmt.warn"), this.$t("jobTypeMgmt.warnDeptName"), "warning");
        return;
      }

      try {
        await axios.post(`${process.env.VUE_APP_APP_URL}/category`, {
          departmentName: this.newDepartmentName,
        });

        Swal.fire(this.$t("mgmt.success"), this.$t("jobTypeMgmt.addDeptOk"), "success");
        this.addModal = false;
        this.loadCategories();
      } catch (err) {
        Swal.fire(this.$t("mgmt.error"), err.response?.data?.message, "error");
      }
    },

    // เปิด modal edit
    openEditModal(item) {
      this.selectedDepartment = JSON.parse(JSON.stringify(item));
      this.selectedSubCategories = [];
      this.editModal = true;
    },

    addSubCategory() {
      this.selectedDepartment.subCategories.push({
        name: "",
        slaHours: 1,
        isActive: true,
        icon: null,
      });
    },

    triggerFileUpload(index) {
      this.currentUploadIndex = index;
      this.$refs.iconInput.click();
    },

    clearIcon(index) {
      if (this.selectedDepartment && this.selectedDepartment.subCategories[index]) {
        Swal.fire({
          title: this.$t("jobTypeMgmt.removeIconTitle"),
          text: this.$t("jobTypeMgmt.removeIconText"),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: this.$t("mgmt.confirmDelete"),
          cancelButtonText: this.$t("mgmt.cancel")
        }).then((result) => {
          if (result.isConfirmed) {
            this.selectedDepartment.subCategories[index].icon = null;
          }
        });
      }
    },

    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("image", file);

      try {
        const res = await axios.post(`${process.env.VUE_APP_APP_URL}/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        if (res.data.success) {
          if (this.currentUploadIndex !== null && this.selectedDepartment) {
            this.selectedDepartment.subCategories[this.currentUploadIndex].icon = res.data.path;
          }
          Swal.fire({
            icon: 'success',
            title: this.$t("jobTypeMgmt.uploadToast"),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (err) {
        console.error("Upload Error:", err);
        Swal.fire(this.$t("mgmt.error"), this.$t("jobTypeMgmt.uploadErr"), "error");
      } finally {
        // clear input value so same file can be selected again
        this.$refs.iconInput.value = null;
        this.currentUploadIndex = null;
      }
    },

    removeSubCategory(index) {
      // confirm delete step 1
      Swal.fire({
        title: this.$t("jobTypeMgmt.delSubTitle"),
        text: this.$t("jobTypeMgmt.delSubText"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("mgmt.delete"),
        cancelButtonText: this.$t("mgmt.cancel")
      }).then((result) => {
        if (result.isConfirmed) {
          // confirm delete step 2
          Swal.fire({
            title: this.$t("mgmt.sureDelete"),
            text: this.$t("jobTypeMgmt.permanent"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: this.$t("mgmt.confirmDelete"),
            cancelButtonText: this.$t("mgmt.cancel")
          }).then((result2) => {
            if (result2.isConfirmed) {
              this.selectedDepartment.subCategories.splice(index, 1);
            }
          })
        }
      })
    },

    toggleSelectAllSub(checked) {
      if (checked && this.selectedDepartment && this.selectedDepartment.subCategories) {
        this.selectedSubCategories = this.selectedDepartment.subCategories.map((_, i) => i);
      } else {
        this.selectedSubCategories = [];
      }
    },

    removeSelectedSubCategories() {
      Swal.fire({
        title: this.$t("jobTypeMgmt.delBulkSubTitle"),
        text: this.$t("jobTypeMgmt.delBulkSubLine").replace("{n}", String(this.selectedSubCategories.length)),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("mgmt.delete"),
        cancelButtonText: this.$t("mgmt.cancel")
      }).then((result) => {
        if (result.isConfirmed) {
          const sortedIndices = [...this.selectedSubCategories].sort((a, b) => b - a);
          for (const i of sortedIndices) {
            this.selectedDepartment.subCategories.splice(i, 1);
          }
          this.selectedSubCategories = [];
        }
      });
    },

    async saveChanges() {
      const hasEmpty = this.selectedDepartment.subCategories.some(
        sub => !sub.name.trim() || !sub.slaHours
      );

      if (hasEmpty) {
        Swal.fire(this.$t("mgmt.warn"), this.$t("jobTypeMgmt.warnComplete"), "warning");
        return;
      }
      try {
        await axios.put(
          `${process.env.VUE_APP_APP_URL}/category`,
          this.selectedDepartment
        );

        Swal.fire(this.$t("mgmt.success"), this.$t("mgmt.saveSaved"), "success");
        this.editModal = false;
        this.loadCategories();
      } catch (err) {
        Swal.fire(this.$t("mgmt.error"), err.response?.data?.message || this.$t("mgmt.saveFail"), "error");
      }
    },

    async removeDepartment(item) {
      Swal.fire({
        title: this.$t("jobTypeMgmt.delDeptTitle"),
        text: this.$t("jobTypeMgmt.delDeptLine").replace("{name}", item.departmentName),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("mgmt.delete"),
        cancelButtonText: this.$t("mgmt.cancel")
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: this.$t("mgmt.sureDelete"),
            text: this.$t("jobTypeMgmt.deptWillDeleteLine").replace("{name}", item.departmentName),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: this.$t("mgmt.confirmDelete"),
            cancelButtonText: this.$t("mgmt.cancel")
          }).then(async (result2) => {
            if (result2.isConfirmed) {
              try {
                await axios.delete(`${process.env.VUE_APP_APP_URL}/category/${item._id}`);
                Swal.fire(this.$t("mgmt.success"), this.$t("jobTypeMgmt.delDeptOk"), "success");
                this.loadCategories();
              } catch (err) {
                Swal.fire(this.$t("mgmt.error"), err.response?.data?.message || this.$t("mgmt.deleteFail"), "error");
              }
            }
          })
        }
      })
    },

    onFilteredItemsChange(items) {
      this.filteredCategories = items;
    },

    toggleSelectAll(checked) {
      const pageIds = this.currentPageCategories.map(c => c._id);
      if (checked) {
        const newSelected = [...this.selectedCategories];
        pageIds.forEach(id => {
          if (!newSelected.includes(id)) {
            newSelected.push(id);
          }
        });
        this.selectedCategories = newSelected;
      } else {
        this.selectedCategories = this.selectedCategories.filter(id => !pageIds.includes(id));
      }
    },

    async deleteMultipleCategories() {
      Swal.fire({
        title: this.$t("jobTypeMgmt.delDeptBulkTitle"),
        text: `${this.$t("jobTypeMgmt.delDeptBulkText")} ${this.selectedCategories.length} ${this.$t("mgmt.itemsUnit")}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("mgmt.delete"),
        cancelButtonText: this.$t("mgmt.cancel")
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: this.$t("mgmt.sureDelete"),
            text: this.$t("jobTypeMgmt.deptsWillDelete"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: this.$t("mgmt.confirmDelete"),
            cancelButtonText: this.$t("mgmt.cancel")
          }).then(async (result2) => {
            if (result2.isConfirmed) {
              Swal.fire({
                title: this.$t("mgmt.loadingDelete"),
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });

              let successCount = 0;
              let failCount = 0;

              for (const catId of this.selectedCategories) {
                try {
                  await axios.delete(`${process.env.VUE_APP_APP_URL}/category/${catId}`);
                  successCount++;
                } catch (err) {
                  failCount++;
                }
              }

              Swal.fire({
                title: failCount === 0 ? this.$t("mgmt.success") : this.$t("mgmt.doneTitle"),
                html: `${this.$t("mgmt.batchDeleted")} ${successCount} ${this.$t("mgmt.itemsUnit")}` + (failCount > 0 ? `<br>${this.$t("mgmt.batchFailed")} ${failCount} ${this.$t("mgmt.itemsUnit")}` : ""),
                icon: failCount === 0 ? "success" : "warning"
              });
              
              this.selectedCategories = [];
              this.loadCategories();
            }
          })
        }
      })
    },
    triggerExcelUpload() {
      this.$refs.excelInput.click();
    },

    handleExcelUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      Swal.fire({
        title: this.$t("mgmt.loadingRead"),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          // Force expand the reference range just in case the file has broken !ref metadata.
          // This ensures we scan up to 2000 rows regardless of what the file reports.
          let rangeStr = worksheet['!ref'];
          if (rangeStr) {
             try {
               let range = XLSX.utils.decode_range(rangeStr);
               range.e.r = Math.max(range.e.r, 2000); // Scan deeply
               worksheet['!ref'] = XLSX.utils.encode_range(range);
             } catch(err) {
               console.warn("Could not modify !ref", err);
             }
          }

          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "", blankrows: false });
          const parsedDepts = [];

          for (const row of jsonData) {
            if (!row || !Array.isArray(row) || row.length === 0) continue;
            
            let parts = [];
            for (let i = 0; i < row.length; i++) {
              const cellValue = row[i];
              if (cellValue != null && String(cellValue).trim() !== "") {
                const strVal = String(cellValue).trim();
                // Check if it's text (not purely numeric). If text, we assume it's part of the department name
                if (isNaN(Number(strVal))) {
                  parts.push(strVal);
                }
              }
            }

            let deptName = parts.join(" ");
            
            // Fallback: If only numbers were found in this row, take the last number block
            if (deptName === "") {
              for (let i = row.length - 1; i >= 0; i--) {
                if (row[i] != null && String(row[i]).trim() !== "") {
                  deptName = String(row[i]).trim();
                  break;
                }
              }
            }

            if (deptName !== "") {
               parsedDepts.push({ departmentName: deptName });
            }
          }

          if (parsedDepts.length === 0) {
            Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.noData"), "warning");
            return;
          }

          this.previewDepts = parsedDepts;
          this.showPreviewModal = true;
          Swal.close();

          event.target.value = null;

        } catch (error) {
          console.error(error);
          Swal.fire(this.$t("mgmt.error"), this.$t("mgmt.fileReadError"), "error");
          event.target.value = null;
        }
      };

      reader.readAsArrayBuffer(file);
    },

    async confirmUpload() {
      if (this.previewDepts.length === 0) {
        Swal.fire(this.$t("mgmt.noData"), this.$t("mgmt.noDataToSave"), "warning");
        return;
      }

      Swal.fire({
        title: this.$t("mgmt.loadingSave"),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      let successCount = 0;
      let failCount = 0;
      const errors = [];

      for (const dept of this.previewDepts) {
        try {
          const res = await axios.post(`${process.env.VUE_APP_APP_URL}/category`, {
            departmentName: dept.departmentName
          });
          if (res.data) {
            successCount++;
          }
        } catch (apiErr) {
          failCount++;
          errors.push(`${dept.departmentName}: ${apiErr.response?.data?.message || apiErr.message}`);
        }
      }

      let msg = `${this.$t("mgmt.batchAdded")} ${successCount} ${this.$t("mgmt.itemsUnit")}`;
      if (failCount > 0) {
        msg += `<br>${this.$t("mgmt.batchFailed")} ${failCount} ${this.$t("mgmt.itemsUnit")}`;
        const errSample = errors.slice(0, 3).join("<br>");
        msg += `<br><div style="font-size: 0.85em; color: dimgray; margin-top: 10px; max-height: 100px; overflow-y: auto; text-align: left;">${errSample}</div>`;
        console.warn("Upload errors:", errors);
      }

      Swal.fire({
        title: failCount === 0 ? this.$t("mgmt.doneTitle") : this.$t("mgmt.donePartial"),
        html: msg,
        icon: failCount === 0 ? "success" : "warning"
      });

      this.showPreviewModal = false;
      this.previewDepts = [];
      this.addModal = false;
      this.loadCategories();
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: disc;
}

.fixed-table {
  table-layout: fixed;
  width: 100%;
}

.fixed-table th,
.fixed-table td {
  text-align: left;
  vertical-align: middle;
  word-wrap: break-word;
}

.col-50 {
  width: 50%;
}

.col-30 {
  width: 30%;
}

.col-20 {
  width: 20%;
}

.col-10 {
  width: 10%;
}
</style>
